import React from 'react';
import { ASSETS, CREDITS, LINKS, APP_VERSION } from '../../lib/constants';

function Footer() {
    return (
        <footer className="clash-footer">
            <div className="footer-content">
                {/* OCC Games Brand */}
                <div className="footer-brand">
                    <img
                        src={ASSETS.occGamesLogo}
                        alt="Roslyn OCC Games"
                        className="footer-logo"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </div>

                {/* Game Icons */}
                <div className="footer-game-icons">
                    <a href="https://clashdle.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Clashdle">
                        <img src="/Clashdle Icon.png" alt="Clashdle" className="footer-game-icon" />
                    </a>
                    <a href="https://clashconnections.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Connections">
                        <img src="/Connections Icon.png" alt="Connections" className="footer-game-icon" />
                    </a>
                    <a href="https://clashstrands.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Strands">
                        <img src="/Strands Icon.png" alt="Strands" className="footer-game-icon" />
                    </a>
                    <a href="https://clashwordchain.roslynocc.com" target="_blank" rel="noopener noreferrer" title="Word Chain">
                        <img src="/Wordchain Icon.png" alt="Word Chain" className="footer-game-icon" />
                    </a>
                </div>

                <div className="footer-divider" />

                {/* Credits */}
                <p className="footer-credits">
                    Created by <span className="footer-highlight">{CREDITS.developers.join(" & ")}</span>
                </p>

                {/* Links */}
                <div className="footer-links">
                    <a
                        href={LINKS.occ}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        Visit OCC
                    </a>
                    <span className="footer-link-sep">•</span>
                    <a
                        href={LINKS.privacy}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="footer-link"
                    >
                        Privacy
                    </a>
                </div>

                {/* Copyright */}
                <p className="footer-copyright">
                    © {CREDITS.year} {CREDITS.organization} · v{APP_VERSION}
                </p>
            </div>
        </footer>
    );
}

export default Footer;
